import React, { useState, useEffect, useContext } from "react";
import { Container, Col, Row } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import renderHTML from "react-render-html";
import URLstateContext from "../../../../provider/CommonContext";
import { Vortex } from "react-loader-spinner";
import animation from "../../../../images/jm-animation.gif";
import "./FAQ.css";

import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../../../provider/ServiceProvider";
import { trackEvent, trackPageView } from "../../../utils/tracking";
import { Helmet, HelmetProvider } from "react-helmet-async";

function FinQFAQ() {
  useEffect(() => {
    trackPageView("https://www.jmfinancialmf.com/FAQs", "jmf_insights_faq");
    // trackPageView('http://localhost:710/FAQs', 'jmf_insights_faq');

    trackEvent({
      category: "Static Page",
      action: "FAQs Page Loaded",
      label: "jmf_insights_faq",
      value: 1,
    });
  }, []);

  const [data, setData] = useState(false);
  const { BaseURL } = useContext(URLstateContext);
  const [loadingshow, setloadingshow] = useState(false);
  useEffect(() => {
    setloadingshow(true);
    GetPostMethodData(BaseURL + "GetFAQ", {
      faqcatid: "4",
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setData(DecryptAESdata(data.data));
        setloadingshow(false);
      }
    });
  }, [BaseURL]);


  return (
    <>
      <HelmetProvider>
        <Helmet>
          <meta charset="UTF-8" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <meta
            name="description"
            content="Find answers to commonly asked questions about mutual funds at JM Financial Mutual Fund. Get clarity on investments, KYC, NAVs, and more."
          />
          <title>
            Frequently Asked Questions | Mutual Fund Queries Answered | JM
            Financial Mutual Fund
          </title>
        </Helmet>
      </HelmetProvider>

     <main  id="main-content" tabIndex="-1">
      <section className="">
        <nav aria-label="Breadcrumb">
        <Container>
          <Row>
            <Col>
              <ul className="navigator-arrow">
                <li>
                  <a href="/" aria-label="Home">
                    <i className="fa fa-home" aria-hidden="true"></i>
                  </a>{" "}
                  <i className="fa fa-angle-right" aria-hidden="true"></i>
                </li>
                <li>FAQs</li>
              </ul>
            </Col>
          </Row>
        </Container>

        </nav>
        <Container>
          <div className="faq-inner-main ">
            <h2
              style={{
                textAlign: "center",
                fontWeight: "bold",
                padding: "28px 12px",
                color: "#000",
              }}
            >
              FAQs
            </h2>
            <Row>
              <Col>
                {/* <h5 className="finqFaq">Online Empanellment</h5> */}
                {/* {data && data.length > 0 ? ( */}
                {loadingshow ? (
                  <div className="textcentervertex HomeLoader" role="status" aria-live="polite" aria-busy="true">
                    <img src={animation} alt="" aria-hidden="true" />
                    <div className="model_popup">Please Wait...</div>
                  </div>
                ) : (
                  <div>
                    {data.length === 0 ? (
                      <h5 className="errormsgComNew" role="alert">No Data Available</h5>
                    ) : (
                      <>
                        {data &&
                          data.map(({ heading, description }) => (
                            <Accordion className="accordionFinQ">
                              <Accordion.Item eventKey="0">
                                <Accordion.Header>{heading}</Accordion.Header>
                                <Accordion.Body className="textjustify">
                                  {/* {renderHTML(description)} */}
                                  {/* {description} */}
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: description,
                                    }}
                                  />
                                  {/* <p>
                            Schemes according to Maturity Period:
                          </p>
                          <p>
                            A mutual fund scheme can be classified into open-ended scheme or close-ended scheme depending on its maturity period.
                          </p>
                          <ul className="diamond-li">
                            <li>Open-ended Fund/ Scheme
                              <p>An open-ended fund or scheme is one that is available for subscription and repurchase on a continuous basis. These schemes do not have a fixed maturity period. Investors can conveniently buy and sell units at Net Asset Value (NAV) related prices which are declared on a daily basis. The key feature of open-end schemes is liquidity.</p>
                            </li>
                            <li>Close-ended Fund/ Scheme
                              <p>A close-ended fund or scheme has a stipulated maturity period e.g. 5-7 years. The fund is open for subscription only during a specified period at the time of launch of the scheme. Investors can invest in the scheme at the time of the initial public issue and thereafter they can buy or sell the units of the scheme on the stock exchanges where the units are listed. In order to provide an exit route to the investors, some close-ended funds give an option of selling back the units to the mutual fund through periodic repurchase at NAV related prices. SEBI Regulations stipulate that at least one of the two exit routes is provided to the investor i.e. either repurchase facility or through listing on stock exchanges. These mutual funds schemes disclose NAV generally on weekly basis.</p>
                            </li>
                            <li>Schemes according to Investment Objective:
                              <p>A scheme can also be classified as growth scheme, income scheme, or balanced scheme considering its investment objective. Such schemes may be open-ended or close-ended schemes as described earlier. Such schemes may be classified mainly as follows:</p>
                            </li>
                            <li>Growth / Equity Oriented Scheme
                              <p>The aim of growth funds is to provide capital appreciation over the medium to long- term. Such schemes normally invest a major part of their corpus in equities. Such funds have comparatively high risks. These schemes provide different options to the investors like dividend option, capital appreciation, etc. and the investors may choose an option depending on their preferences. The investors must indicate the option in the application form. The mutual funds also allow the investors to change the options at a later date. Growth schemes are good for investors having a long-term outlook seeking appreciation over a period of time.</p>
                            </li>
                            <li>Income / Debt Oriented Scheme
                              <p>The aim of income funds is to provide regular and steady income to investors. Such schemes generally invest in fixed income securities such as bonds, corporate debentures, Government securities and money market instruments. Such funds are less risky compared to equity schemes. These funds are not affected because of fluctuations in equity markets. However, opportunities of capital appreciation are also limited in such funds. The NAVs of such funds are affected because of change in interest rates in the country. If the interest rates fall, NAVs of such funds are likely to increase in the short run and vice versa. However, long term investors may not bother about these fluctuations.</p>
                            </li>
                          </ul>
                          <a className="view-more-link" href="/FinQ">View More</a> */}
                                </Accordion.Body>
                              </Accordion.Item>
                            </Accordion>
                          ))}
                      </>
                    )}
                  </div>
                )}

                {/* ) : (
                <h5 className="errormsgComNew">No Data Found !!!</h5>
              )}
              {loadingshow ? <div className="textcentervertex">
                <img src={animation} alt="Loading" />
                <div className="model_popup">Please Wait...</div>
              </div> : ""
              } */}
              </Col>
            </Row>
          </div>
        </Container>
      </section>
     </main>
    </>
  );
}

export default FinQFAQ;
